export const uk = {
    continue: 'Продолжить?',
    'pay-will-not-apply-for-campaigns': 'Выбранное действие недоступно для кампаний:'
};
